module.exports = __webpack_public_path__ + "static/media/JS.dc895e44.svg";